import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Import the package stylesheets directly. The package index modules are
// side-effect-free in production builds, so their own CSS imports are dropped.
import "../../../packages/heavy-rain-ui/src/styles.css";
import "../../../packages/organization-ui/src/styles.css";
import "./styles/app.css";
import { App } from "./App";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Missing #root container in apps/system/index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
